import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { FullBathroomRemodelingPage } from './pages/FullBathroomRemodelingPage';
import { TubToShowerConversionPage } from './pages/TubToShowerConversionPage';
import { CustomTileWorkPage } from './pages/CustomTileWorkPage';
import { VanityInstallationPage } from './pages/VanityInstallationPage';
import { AccessibilityUpgradesPage } from './pages/AccessibilityUpgradesPage';
import { FlooringAndLightingPage } from './pages/FlooringAndLightingPage';
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen bg-white font-sans text-gray-900 antialiased selection:bg-[#8BA888] selection:text-white" data-id="element-1">
        {/* Eyebrow Bar */}
        <div className="bg-[#8BA888] text-white py-2.5 text-center text-sm font-medium" data-id="element-2">
          Bathroom Remodeling Services in Northern Indiana
        </div>

        <Header data-id="element-3" />
        <main className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
            <Route path="/contact" element={<ContactPage data-id="element-11" />} data-id="element-10" />
            <Route path="/services/full-bathroom-remodeling" element={<FullBathroomRemodelingPage data-id="element-13" />} data-id="element-12" />
            <Route path="/services/tub-to-shower-conversion" element={<TubToShowerConversionPage data-id="element-15" />} data-id="element-14" />
            <Route path="/services/custom-tile-work" element={<CustomTileWorkPage data-id="element-17" />} data-id="element-16" />
            <Route path="/services/vanity-installation" element={<VanityInstallationPage data-id="element-19" />} data-id="element-18" />
            <Route path="/services/accessibility-upgrades" element={<AccessibilityUpgradesPage data-id="element-21" />} data-id="element-20" />
            <Route path="/services/flooring-and-lighting" element={<FlooringAndLightingPage data-id="element-23" />} data-id="element-22" />
          </Routes>
        </main>
        <Footer data-id="element-24" />
      </div>
    </Router>;
}